import { Modal } from '@employ-engage/common-components';
import AddFormForm, {
  FormWithCompleteTargets,
} from '../add-form-form/add-form-form';
import { useTranslation } from 'react-i18next';

export interface AddFormModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  formSelectedForEditing: FormWithCompleteTargets | null;
  refetchForms?: () => void;
}

export function AddFormModal({
  open,
  setOpen,
  formSelectedForEditing,
  refetchForms,
}: AddFormModalProps) {
  const { t } = useTranslation(['common']);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      isFullScreen
      disableCloseOnOutsideClick
      panelClassName="max-h-[100vh] overflow-y-auto"
    >
      <div>
        <div className="text-2xl font-bold leading-9 text-gray-900">
          {formSelectedForEditing ? t('Edit Form') : t('Add Form')}
        </div>
      </div>
      <div className="mt-5">
        <AddFormForm
          formSelectedForEditing={formSelectedForEditing}
          setOpen={setOpen}
          refetchForms={refetchForms}
        />
      </div>
    </Modal>
  );
}

export default AddFormModal;
